import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

import { userMenuList } from "@/api/user"
import { ElMessage } from 'element-plus'
import MenuItem from './menu_item.vue'
import { Ref, ref ,watch,PropType, computed} from 'vue'
import { menuRouter } from '@/utils/base'
import { useRoute } from 'vue-router'

export interface MenuModel {
    name: string,
    icon: string,
    type: number,
    children: Array<MenuModel>,
    path: string,
}

export default /*#__PURE__*/_defineComponent({
  props: {
  icon:{
    type:Object as PropType<string>,
  }
},
  setup(__props) {

const props = __props

components:{
  MenuItem
}
const active_index: any = ref(0)

const get_active_index = computed(() => {
  return active_index
})





const route: any = useRoute();
const menu_list: Ref<Array<MenuModel>> = ref([]);
const isCollapse = ref(false)
watch(()=>props.icon,(val)=>{
   isCollapse.value = val ? false : true
  
})

const get_munu_index_fn = () => {
  let route_path = route.path
  if(route_path === '/iframe') {
    route_path = route.query.u
  }
  for (let i = 0; i < menu_list.value.length; i++) {
    if(menu_list.value[i].path === route_path) {
      active_index.value = i
    }
    if(! menu_list.value[i].children) continue;
    for (let j = 0; j < menu_list.value[i].children.length; j++) {
      let child_obj: any = menu_list.value[i].children[j]
      if(child_obj.path === route_path){ 
        active_index.value = i + '-' + j
      }
      
    }
    
  }
}


let newVal = ref()
 menuRouter().then((res:any)=>{
    console.log('res',res);
  menu_list.value.push(...res)
   console.log('menu_list.value1',menu_list.value);
   get_munu_index_fn();
 })
userMenuList().then(async(res: any) => {
 
  // if(res.code === 200) {
  //   menu_list.value = res.datas
  // } else {
  //   ElMessage.error(res.error);
  // }
}).catch((err: any) => {
  console.log(err)
})



watch(()=>route.path,(newval)=>{
   console.log('newVal',newval);
   newVal.value = newval
   
})

    

return (_ctx: any,_cache: any) => {
  const _component_el_menu = _resolveComponent("el-menu")!

  return (_openBlock(), _createBlock(_component_el_menu, {
    "default-active": _unref(get_active_index),
    collapse: isCollapse.value,
    class: "el-menu-vertical-demo"
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menu_list.value, (item, index) => {
        return (_openBlock(), _createBlock(MenuItem, {
          key: index,
          menu_item: item,
          key_name: index
        }, null, 8, ["menu_item", "key_name"]))
      }), 128))
    ]),
    _: 1
  }, 8, ["default-active", "collapse"]))
}
}

})